'use strict';

var Sugar = require('sugar-core');

require('../enumerable/build/buildFromIndexMethodsCall');

module.exports = Sugar.Array.findIndexFromIndex;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/findIndexFromIndex.js
// module id = 375
// module chunks = 0